import { fromString } from "@cloudspire/legacy-resources/src/libraries/EnhancedDate";
import bookingEstimateHasResume from "../hasResume";

/**
 * Retourne les informations à afficher pour le résumé du voyage.
 */
export default function bookingEstimateGetResume({ bookingEstimate }) {
  if (!bookingEstimateHasResume({ bookingEstimate })) {
    return null;
  }

  return {
    checkin: fromString(bookingEstimate.checkin, "Y-m-d").getNativeDate(),
    departure: fromString(bookingEstimate.departure, "H:i").getNativeDate(),
    checkout: fromString(bookingEstimate.checkout, "Y-m-d").getNativeDate(),
    arrival: fromString(bookingEstimate.arrival, "H:i").getNativeDate(),
    adults: bookingEstimate.adults,
    childs: bookingEstimate.childs,
    babies: bookingEstimate.babies,
    pets: bookingEstimate.pets,
  };
}
